import { API, API_POST } from "../../Config";

export const handleUpdateVoucher = (payload) => {
  const f = new FormData();

  f.append("name", payload.name);
  f.append("description", payload.description);
  f.append("image", payload.image);
  f.append("code", payload.code);
  f.append("link", payload.link);
  f.append("discount_type", payload.discount_type);
  f.append("discount_value", payload.discount_value);
  f.append("voucher_type", payload.voucher_type);
  
  f.append("id", payload.id);

  return API_POST(API.editvoucher, f);
};
